import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import ReactMarkdown from "react-markdown"

const About = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/contents/aboutme.md")
      .then((res) => res.text())
      .then((text) => setContent(text));
  }, []);

  return (
    <Container className='text-left mt-5 mb-5 w-75'>
      <ReactMarkdown children={content} />
    </Container>
  )
}

export default About